export const RoutePaths = {
  home: 'mybrightlink',
  login: 'login',
  register: 'register',
  saved: 'saved',
  sessionFeedback: 'session-feedback',
  resources: 'resources',
  dimensions: 'dimension-parent-class',
  courses: 'parent-led-curriculum',
  articles: 'articles',
  events: 'events',
  category: 'category',
  care: 'care',
  community: 'community',
  messages: 'messages',
  info: 'info',
  careTeam: 'care-team',
  sla: 'sla',
  members: 'members',
  gallery: 'gallery',
  profile: 'profile',
  basic: 'basic',
  interests: 'interests',
  behaviors: 'behaviors',
  survey: 'survey',
  progressPortrait: 'progress-portrait',
};

const {
  home,
  login,
  register,
  saved,
  sessionFeedback,
  resources,
  courses,
  dimensions,
  articles,
  events,
  category,
  care,
  community,
  messages,
  info,
  careTeam,
  sla,
  profile,
  gallery,
  members,
  basic,
  interests,
  behaviors,
  progressPortrait,
} = RoutePaths;

export const Routes = {
  authenticated: `/${home}`,
  login: `/${home}/${login}`,
  register: `/${home}/${register}`,
  saved: `/${home}/${saved}`,
  sessionFeedback: `/${home}/${sessionFeedback}`,
  resources: {
    index: `/${home}/${resources}`,
    courses: {
      index: `/${home}/${resources}/${courses}`,
      courseId: (courseId: number) =>
        `/${home}/${resources}/${courses}/${courseId}`,
      lessonId: (courseId: number | string, lessonId: number) =>
        `/${home}/${resources}/${courses}/${courseId}/${lessonId}`,
      quizId: (
        courseId: number | string,
        lessonId: number | string,
        quizId: number | string,
      ) => `/${home}/${resources}/${courses}/${courseId}/${lessonId}/${quizId}`,
    },
    dimensions: {
      index: `/${home}/${resources}/${dimensions}`,
      postId: (postId: number) =>
        `/${home}/${resources}/${dimensions}/${postId}`,
    },
    articles: {
      index: `/${home}/${resources}/${articles}`,
      categoryId: (categoryId: number) =>
        `/${home}/${resources}/${articles}/${category}/${categoryId}`,
      slug: (slug: string, categoryId: string) =>
        `/${home}/${resources}/${articles}/${category}/${categoryId}/${slug}`,
    },
    events: {
      index: `/${home}/${resources}/${events}`,
      categoryId: (categoryId: number) =>
        `/${home}/${resources}/${events}/${category}/${categoryId}`,
      postId: (postId: number, categoryId: string) =>
        `/${home}/${resources}/${events}/${category}/${categoryId}/${postId}`,
    },
    child: (path: string) => `/${home}/${resources}/${path}`,
  },
  care: {
    index: `/${home}/${care}`,
    child: (path: string) => `/${home}/${care}/${path}`,
  },
  community: {
    index: `/${home}/${community}`,
  },
  messages: {
    index: `/${home}/${messages}`,
    info: `/${home}/${messages}/${info}`,
    channel: {
      conversation: (channelGuid: string) =>
        `/${home}/${messages}/${channelGuid}`,
      gallery: (channelGuid: string) =>
        `/${home}/${messages}/${channelGuid}/${gallery}`,
      members: (channelGuid: string) =>
        `/${home}/${messages}/${channelGuid}/${members}`,
    },
    careTeam: {
      sla: `/${home}/${messages}/${careTeam}/${sla}`,
    },
    community: {
      index: `/${home}/${messages}/${community}`,
      sla: `/${home}/${messages}/${community}/${sla}`,
    },
  },
  profile: {
    index: `/${home}/${profile}`,
    basic: `/${home}/${profile}/${basic}`,
    interests: `/${home}/${profile}/${interests}`,
    behaviors: `/${home}/${profile}/${behaviors}`,
  },
  progressPortrait: {
    index: `/${home}/${progressPortrait}`,
  },
};
